module.exports = __webpack_public_path__ + "img/food-service ops-min.b5de3a55.jpg";